module.exports = __webpack_public_path__ + "static/media/holiday.34665126.png";